import { Box, Button, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { GrFormClose } from "react-icons/gr";
export const TriviaDetails = ({
  triviaDetails,
  botDetails,
  knowMoreAboutIt,
  startChatFromTrivia,
  isColorDark,
  closeTrivia,
  isloading,
  openChatBot,
}) => {
  const MotionBox = motion(Box);
  return (
    <Box
      p={"14px"}
      boxShadow="rgba(0, 0, 0, 1) 0px 10px 30px 10px"
      border={"2px"}
      borderRadius={"10px"}
      width={"280px"}
      mb={"16px"}
      onClick={openChatBot}
      cursor={"pointer"}
      bgColor={"white"}
    >
      <Box float={"right"} onClick={(e)=>{
        e.stopPropagation();
        closeTrivia()}}>
        <GrFormClose fontSize={"20px"} />
      </Box>
      <Box display={"flex"} alignItems={"center"}>
        {/* <Image
              src={botDetails.companyLogo}
              w={"28px"}
              h={"30px"}
              mr={"10px"}
            /> */}
        {/* <Heading fontSize={"16px"} style={{ margin: 0, lineHeight: 0 }}>
              {botDetails.companyName}
            </Heading> */}
      </Box>
      <>
        {" "}
        <Text fontSize={"13px"}>{triviaDetails?.trivia?.trivia}</Text>
        <MotionBox
          display="flex"
          justifyContent="space-around"
          mt="10px"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <Box
            display={"flex"}
            justifyContent={"space-around"}
            marginTop={"10px"}
          >
            {triviaDetails?.trivia?.buttons?.map((el) => {
              return (
                <Button
                  isLoading={isloading}
                  size="xs"
                  style={{
                    padding: "8px",
                    background: botDetails.accentColor,
                    borderRadius: "10px",
                    fontSize: "13px",
                    cursor: "pointer",
                    boxShadow: "md",
                    display: "flex",
                    alignItems: "center",
                    height: "29px",
                    border: `1px solid ${botDetails.accentColor}`,
                    color: isColorDark(botDetails?.accentColor)
                      ? "white"
                      : "black",
                    transition: "all 0.2s ease-in-out",
                  }}
                  onClick={() => {
                    if (el.text.toLowerCase() == "show products") {
                      knowMoreAboutIt("show me products");
                    } else if (el.text.toLowerCase() == "let's discuss") {
                      startChatFromTrivia();
                    } else if (el.text.toLowerCase() == "talk to an expert") {
                      startChatFromTrivia();
                    } else {
                      knowMoreAboutIt(el.text);
                    }
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.border = `1px solid ${botDetails.accentColor}`;
                    e.target.style.backgroundColor = "white";
                    e.target.style.color = isColorDark(botDetails?.accentColor)
                      ? botDetails.accentColor
                      : "black";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.border = `1px solid ${botDetails.accentColor}`;
                    e.target.style.backgroundColor = botDetails.accentColor;
                    e.target.style.color = isColorDark(botDetails?.accentColor)
                      ? "white"
                      : "black";
                  }}
                >
                  {el.text}
                </Button>
              );
            })}
          </Box>
        </MotionBox>
      </>
    </Box>
  );
};
